import { Box, Typography } from "@mui/material";

export const MessageScreen = ({ title, msg }) => {
  
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: '620px',
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          padding: "40px",
          boxShadow: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "12px",
          background: "#FBFBFD",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
          }}
        >

          <Typography textAlign={"center"} fontSize={"18px"} fontWeight={600}>
            {title}
          </Typography>
          <Typography textAlign={"center"} fontSize={"14px"} fontWeight={400}>
            {msg}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
